module.exports = function(data) {
var __t, __p = '';
__p += '<div class="token">\n    <div class="token-inner-wrapper" data-toggle="tooltip" title="">\n        <span class="operator"></span>\n        <span class="token-label"></span>\n        <i class="fas fa-chevron-down chevron" aria-hidden="true"></i>\n    </div>\n    <a href="#" class="close" tabindex="-1"><i class="fas fa-times-circle token-close-icon" aria-hidden="true"></i></a>\n</div>';
return __p
}